import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import { Box, Button, Typography } from "@mui/material";
import { styles } from "./styles";
import { SubscriptionTier } from "../../proto/api_pb";
import { useContext } from "react";
import { UserDetailsContext } from "../../contexts";
import { useGetCustomerPortalLink } from "../../hooks/useGetCustomerPortalLink";

export const StudioPlanDetails: React.FC = (): JSX.Element => {
  const { subscriptionTier } = useContext(UserDetailsContext);
  const { getCustomerPortalLink } = useGetCustomerPortalLink();
  const isUpgradePlanAvailable =
    subscriptionTier < SubscriptionTier.SUBSCRIPTION_TIER_STUDIO;
  return (
    <Box>
      <Box sx={{ display: "flex" }}>
        <Typography sx={{ fontWeight: "bold", fontSize: "40px" }} variant="h4">
          $ 14.99
        </Typography>
        <Box sx={{ paddingLeft: "10px" }}>
          <h6 style={{ margin: 0 }}>per</h6>
          <h6>month</h6>
        </Box>
      </Box>
      <Button
        onClick={getCustomerPortalLink}
        sx={
          isUpgradePlanAvailable
            ? { ...styles.button, width: "100%", margin: 0 }
            : { display: "none" }
        }
      >
        Upgrade
      </Button>
      <ul style={{ padding: "0px", marginTop: "10px", textAlign: "left" }}>
        <li style={styles.planDetailsRow}>
          <CheckCircleRoundedIcon sx={styles.checkCircleRoundedIcon} />
          1TB of Optimized Music & File Storage
        </li>
        <li style={styles.planDetailsRow}>
          <CheckCircleRoundedIcon sx={styles.checkCircleRoundedIcon} />
          Advanced AI-Based Music Organization
        </li>
        <li style={styles.planDetailsRow}>
          <CheckCircleRoundedIcon sx={styles.checkCircleRoundedIcon} />
          Choose to Share Music Publicly or Privately
        </li>
        <li style={styles.planDetailsRow}>
          <CheckCircleRoundedIcon sx={styles.checkCircleRoundedIcon} />
          Profile, Tracks, & NFTs Listed on Explore Page
        </li>
        <li style={styles.planDetailsRow}>
          <CheckCircleRoundedIcon sx={styles.checkCircleRoundedIcon} />
          Tracks & NFTs Added to “Featured Section”
        </li>
        <li style={styles.planDetailsRow}>
          <CheckCircleRoundedIcon sx={styles.checkCircleRoundedIcon} />
          Profile, Tracks, & NFTs Highlighted on Website
        </li>
        <li style={styles.planDetailsRow}>
          <CheckCircleRoundedIcon sx={styles.checkCircleRoundedIcon} />
          Social Media Promotion on OmMuse Socials
        </li>
        <li style={styles.planDetailsRow}>
          <CheckCircleRoundedIcon sx={styles.checkCircleRoundedIcon} />
          Discounted Dolby.io AI Mastering ($4.99/track)
        </li>
        <li style={styles.planDetailsRow}>
          <CheckCircleRoundedIcon sx={styles.checkCircleRoundedIcon} />
          Discounted Smart Contract Minting ($9.99/track)
        </li>
        <li style={styles.planDetailsRow}>
          <CheckCircleRoundedIcon sx={styles.checkCircleRoundedIcon} />
          Unlimited Encrypted Messaging with Users
        </li>
        <li style={styles.planDetailsRow}>
          <CheckCircleRoundedIcon sx={styles.checkCircleRoundedIcon} />
          Update Track Versions With Collaborators
        </li>
        <li style={styles.planDetailsRow}>
          <CheckCircleRoundedIcon sx={styles.checkCircleRoundedIcon} />
          File Share(Session Files, Lyric Sheets, etc)
        </li>
        <li style={styles.planDetailsRow}>
          <CheckCircleRoundedIcon sx={styles.checkCircleRoundedIcon} />
          Shoutout on OmMuse Social Media Channels
        </li>
      </ul>
    </Box>
  );
};
